import CustomApplicationState from "@crescentParts/Store/CustomApplicationState";
import { ProductsDataView } from "@insite/client-framework/Store/Data/Products/ProductsState";

export const getAHRISystemCurrentPageState = (state: CustomApplicationState) => {
    return state?.cpeState?.AHRISystemToolPagination;
}

export const getAHRISystemToolPaginationDataByCategoryId = (state: CustomApplicationState) => {
    const productDataView = state.data.products.dataViews;
    const categoryId = state?.cpeState?.AHRISystemToolConfigCategory.categoryId;
    let selectedCategoryData :ProductsDataView | undefined;
    if(categoryId){
        for (const x in productDataView) {
            if(x.includes("categoryId")){
                const categoryIdInObj = x.split("&")[2].split("=")[1]
                if(categoryIdInObj===categoryId){
                    selectedCategoryData=productDataView[x]
                }
            }
        
        }
        return selectedCategoryData;
    }
    return null;    
}
